import {
    Directive, OnInit, inject
} from "@angular/core";
import { MatDatepicker } from "@angular/material/datepicker";
import { PanelTriggerHostDirective } from "../../../directives/panel-trigger/panel-trigger-host.directive";

/**
 * Attribute directive that wires a `<mat-datepicker>` element into the
 * application's close-all-panels signal via `PanelTriggerHostDirective`.
 *
 * When a hotkey fires, `AppService.closeAllPanels()` is invoked, which causes
 * every subscribed `PanelTriggerHostDirective` to synchronously close its panel —
 * including this one.
 *
 * Must be placed on the `<mat-datepicker>` element, not on the associated input.
 *
 * @example
 * ```html
 * <mat-datepicker mgdDatepickerTrigger #picker></mat-datepicker>
 * <input [matDatepicker]="picker" />
 * ```
 *
 * @selector mat-datepicker[mgdDatepickerTrigger]
 */
@Directive({
    selector: "mat-datepicker[mgdDatepickerTrigger]",
    hostDirectives: [PanelTriggerHostDirective]
})
export class DatepickerTriggerDirective implements OnInit {
    private readonly _picker = inject(MatDatepicker<unknown>, { self: true });
    private readonly _panelTrigger = inject(PanelTriggerHostDirective, { self: true });

    ngOnInit(): void {
        this._panelTrigger.setTrigger(this._picker);
    }
}
